export function deletedFactory<TEntity extends { deleted?: boolean }>(includeDeleted: boolean) {
  return (el: TEntity) => {
    if (includeDeleted) {
      return true
    }

    return !el.deleted
  }
}
